import { render, staticRenderFns } from "./InsightsHub.vue?vue&type=template&id=31aa7076&scoped=true"
import script from "./InsightsHub.vue?vue&type=script&lang=ts"
export * from "./InsightsHub.vue?vue&type=script&lang=ts"
import style0 from "./InsightsHub.vue?vue&type=style&index=0&id=31aa7076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa7076",
  null
  
)

export default component.exports